import * as angular from "angular";

export class SurveyQuestionService {
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.v2Root = "/v2/survey/question";
    }

    delete(sqId: string | number): Promise<object> {
        return this.$http.delete(this.v2Root + "/delete/" + sqId);
    }

    update(surveyQuestion: any): Promise<object> {
        return this.$http.post(
            this.v2Root + "/update/" + surveyQuestion.sqid,
            surveyQuestion
        );
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }
}

angular
    .module("vcServices")
    .service("SurveyQuestionService", SurveyQuestionService);
